export default class DtoCmsDescriptions {
    constructor(obj) {
        this.id = obj.id
        this.cmsId = obj.cmsId
        this.description = obj.description
    }
}
